import React from "react"

const ServicesSelected = () => (
    <div className="travel__selected">
        <div className="container">
            <div className="has-text-white travel__selected--columns">
                <div className="info has-text-centered px-0 mx-0">
                    <p className="pb-5">
                        We have a range of VIP lounges available — whether
                        you're after a more luxurious destination or one popular
                        city. Make your clients travel experience seamless,
                        easier, and exclusive every time.
                    </p>
                </div>
            </div>
        </div>
    </div>
)

export default ServicesSelected
